import { isAuthenticated } from '../utils/auth';

export function selectIsAuthenticated(state) {
  return isAuthenticated(state.auth.status);
}
